const mybutton = document.getElementById("topBtn");

window.onscroll = function () {
  scrollFunction();
};
mybutton.style.display = "none";
function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}

function topFunction() {
  document.documentElement.scrollTop = 0;
}
mybutton.addEventListener("click", topFunction);

//hamburger
const burger = document.querySelector(".hamburger__wrapper");
const navigation = document.querySelector(".top-nav");
const items = document.querySelectorAll(".top-nav__item");
console.log(items);

burger.addEventListener("click", function () {
  this.classList.toggle("open");
  navigation.classList.toggle("show");
});

items.forEach((item) => {
  item.addEventListener("click", function () {
    burger.classList.toggle("open");
    navigation.classList.toggle("show");
  });
});

const modals = document.querySelectorAll(".modal__window");
const readMore = document.querySelectorAll(".btn-learnmore");
const overlays = document.querySelectorAll(".modal__overlay");
const closeModalButtons = document.querySelectorAll(".btn--closeModal");

readMore.forEach((button) => {
  button.addEventListener("click", function () {
    const target = this.dataset.target;
    const modal = document.querySelector(`.modal__window-${target}`);
    if (!modal) return;
    modal.classList.toggle("hidden");
    overlays.forEach((overlay) => overlay.classList.toggle("hidden"));
  });
});

closeModalButtons.forEach((button) => {
  button.addEventListener("click", function () {
    const target = this.dataset.target;
    const modal = document.querySelector(`.modal__window-${target}`);
    if (!modal) return;
    modal.classList.toggle("hidden");
    overlays.forEach((overlay) => overlay.classList.toggle("hidden"));
  });
});

const orderBtns = document.querySelectorAll(".order__btn");

orderBtns.forEach((orderBtn) => {
  orderBtn.addEventListener("click", function (e) {
    modals.forEach((modal) => {
      if (!modal.classList.contains("hidden")) {
        modal.classList.add("hidden");
      }
    });
    overlays.forEach((overlay) => overlay.classList.toggle("hidden"));
  });
});

window.addEventListener("scroll", reveal);

function reveal() {
  var reveals = document.querySelectorAll(".reveal");

  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var revealtop = reveals[i].getBoundingClientRect().top;
    var revealpoint = 150;

    if (revealtop < windowHeight - revealpoint) {
      reveals[i].classList.add("active");
    } else {
      // reveals[i].classList.remove("active");
    }
  }
}
